var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-xs-center elevation-5 mx-2"},[_c('p',{staticClass:"green darken-3 white--text py-1 "},[_vm._t("header")],2),_c('p',{staticClass:"py-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }